import { render } from "./SegmentsTargetingCount.vue?vue&type=template&id=32e00b4c&scoped=true"
import script from "./SegmentsTargetingCount.vue?vue&type=script&lang=js"
export * from "./SegmentsTargetingCount.vue?vue&type=script&lang=js"

import "./SegmentsTargetingCount.vue?vue&type=style&index=0&id=32e00b4c&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e00b4c"]])

export default __exports__